module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('MainRow'), _vm._v(" "), _c('b-modal', {
    ref: "confirmGiveUp",
    attrs: {
      "id": "confirmGiveUp",
      "title": "Vraiment ?"
    },
    on: {
      "ok": function($event) {
        return _vm.giveUp()
      },
      "cancel": function($event) {
        return _vm.chrono()
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Êtes-vous sûr de vouloir abandonner la partie ?")])]), _vm._v(" "), _c('b-container', {
    staticClass: "mt-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "rounded shadow-sm p-2 mb-3",
    staticStyle: {
      "background-color": "#f0f0f0"
    }
  }, [_c('b-col', [_c('h4', {
    staticClass: "mt-1"
  }, [_vm._v("Devinez le mot caché dans ce plateau")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-none d-sm-block",
    attrs: {
      "lg": "3",
      "order": "3",
      "order-lg": "1"
    }
  }, [_c('b-card', {
    attrs: {
      "title": "Règles du jeu"
    }
  }, [_c('p', {
    staticClass: "text-left"
  }, [_vm._v("Essayez de deviner le plus rapidement possible le mot associé à ce tableau."), _c('br'), _vm._v("\n          Vous pouvez proposer autant de mots que vous le souhaitez, à vous d'être le plus rapide.")])])], 1), _vm._v(" "), (!_vm.isBoardAlreadyPlayed(_vm.boardId)) ? _c('b-col', {
    attrs: {
      "lg": "3",
      "order": "2",
      "order-lg": "2"
    }
  }, [_c('b-card', {
    attrs: {
      "title": "Temps écoulé"
    }
  }, [_c('Timer', {
    ref: "timer"
  }), _c('br'), _vm._v(" "), (!_vm.isPlayerGaveUp) ? _c('div', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.chrono()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.btnPlayLabel) + "\n            ")]), _vm._v(" "), (_vm.isPlayingBoard) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.chrono();
        _vm.$refs['confirmGiveUp'].show()
      }
    }
  }, [_vm._v("\n              Abandonner\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isPlayingBoard === false) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.pauseGame()
      }
    }
  }, [_vm._v("\n              Finir plus tard\n            ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isPlayerGaveUp) ? _c('div', [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Partie abandonnée")]), _vm._v(" "), _c('p', {
    staticClass: "card-body"
  }, [_vm._v("Dommage ! Meilleure chance la prochaine fois.")]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("Le mot à trouver était : "), _c('strong', [_vm._v(_vm._s(_vm.getBoardWords(_vm.boardId)[0]))]), _vm._v(".")])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isBoardAlreadyPlayed(_vm.boardId) && !_vm.isPlayerGaveUp) ? _c('b-col', {
    attrs: {
      "lg": "6",
      "order": "1",
      "order-lg": "3"
    }
  }, [_c('b-card', {
    class: {
      'border-success': _vm.isGuessFound
    },
    attrs: {
      "title": "A vous de jouer"
    }
  }, [(!_vm.isGuessFound && !_vm.isPlayerGaveUp) ? _c('b-form', {
    attrs: {
      "inline": ""
    },
    on: {
      "submit": _vm.checkGuess
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Proposez des mots :",
      "label-for": "playerGuess"
    }
  }, [_c('b-form-input', {
    staticClass: "m-3",
    attrs: {
      "id": "playerGuess",
      "state": _vm.isNewGuess,
      "value": "",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.playerGuess),
      callback: function($$v) {
        _vm.playerGuess = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "playerGuess"
    }
  }), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Deviner")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isGuessFound) ? _c('div', [_c('h4', {
    staticClass: "card-body text-success"
  }, [_vm._v("Bravo ! vous avez gagné !!!")]), _vm._v(" "), _c('h6', {
    staticClass: "mb-3"
  }, [_vm._v("Le mot à trouver était : "), _c('strong', [_vm._v(_vm._s(_vm.getBoardWords(_vm.boardId)[0]))]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "text-left ml-2",
    attrs: {
      "id": "playerGuessWords"
    }
  }, _vm._l((_vm.playerGuessWords), function(word) {
    return _c('li', [_c('span', {
      staticClass: "fa-li ml-5"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "question",
        "color": _vm.colors[0]
      }
    })], 1), _vm._v(_vm._s(word) + "\n            ")])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isBoardAlreadyPlayed(_vm.boardId)) ? _c('b-col', [_c('b-card', {
    attrs: {
      "title": "Encore vous ?"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._v("\n            Vous avez déjà joué à ce plateau \n            "), (_vm.getBoardPlayerInfo(_vm.boardId)['found']) ? _c('span', [_vm._v("et vous avez trouvé en")]) : _vm._e(), _vm._v(" "), (_vm.getBoardPlayerInfo(_vm.boardId)['gaveUp']) ? _c('span', [_vm._v("et vous aviez abandonné au bout de")]) : _vm._e(), _vm._v("\n             " + _vm._s(_vm.timeSpent) + "."), _c('br'), _vm._v("\n            Le mot à trouver était : "), _c('b', [_vm._v(_vm._s(_vm.getBoardWords(_vm.boardId)[0]))]), _vm._v("."), _c('br'), _vm._v("\n            Voulez-vous en "), _c('b-link', {
    attrs: {
      "to": {
        name: 'BoardsTable'
      }
    }
  }, [_vm._v("essayer un autre ?")])], 1)])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381ef43e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/playboard.vue
// module id = vFYR
// module chunks = 1